<div class="pnl-register-event">
  <app-event-form></app-event-form>
</div>